import { ToastManagerRepository } from "@core/domain/repositories/toast-manager.repository.ts";
import type { Nullable } from "@core/domain/types/nullable.type";
import type { RouteFilter } from "@station/domain/models/route.model";
import { Route } from "@station/domain/models/route.model";
import type { RouteRepository } from "@station/domain/repositories/route.repository";
import { stationsTypes } from "@station/station-types.di.ts";
import { inject, injectable } from "inversify";

@injectable()
export class RouteGetAllUseCase {
    constructor(
        @inject(stationsTypes.repositories.RouteRepository)
        private readonly routeRepository: RouteRepository,
    ) {}

    async execute(routeFilter: RouteFilter): Promise<Nullable<Route>> {
        const routeResult = await this.routeRepository.getAllRoute(routeFilter);

        if (routeResult.isErr()) {
            ToastManagerRepository.error(routeResult.error.message);
        }

        return routeResult.match(
            (route) => route,
            () => null,
        );
    }
}
